module.exports = __webpack_public_path__ + "static/media/french_roulette.netent.22b1a72d.jpeg";